export interface TeacherPasswordRequest {
  newPassword: string;
  password?: string;
}

export class TeacherPasswordReset {
  email: string
  accessEntryID: number

  deserialize(input: any): TeacherPasswordReset {
    this.accessEntryID = input.accessEntryID;
    this.email = input.email;

    return this;
  }
}